import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import VisaPaymentPanel from '../shared/components/payments/VisaPaymentPanel';
import PaymentAttemptsList from '../shared/components/payments/PaymentAttemptsList';

export default function SalesBilling() {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const qInvoiceId = params.get('invoiceId');
  const qAmount = params.get('amount');

  const [invoiceId, setInvoiceId] = useState(qInvoiceId || '');
  const [invoice, setInvoice] = useState(() => ({
    invoice_id: qInvoiceId || `BILL-${Date.now()}`,
    totals: { total: qAmount ? parseFloat(qAmount) : 0 },
    paymentAttempts: []
  }));

  useEffect(() => {
    if (qInvoiceId) {
      setInvoiceId(qInvoiceId);
      setInvoice(prev => ({ ...prev, invoice_id: qInvoiceId }));
    }
    if (qAmount) {
      setInvoice(prev => ({ ...prev, totals: { total: parseFloat(qAmount) } }));
    }
  }, [qInvoiceId, qAmount]);

  function handleUpdateInvoice(updated) {
    setInvoice(updated);
    if (updated && updated.invoice_id) setInvoiceId(updated.invoice_id);
  }

  const navigate = useNavigate();

  return (
    <div className="min-h-screen surface p-6">
      <div className="flex gap-6">
        {/* Sidebar */}
        <aside className="w-60 bg-ink/90 border border-edge/30 rounded-hard p-4">
          <div className="mb-6">
            <div className="text-ice font-bold text-lg">Finance Core</div>
          </div>

          <nav className="space-y-2">
            <button onClick={() => navigate('/')} className="w-full text-left px-3 py-3 rounded-none text-ice hover:bg-ink/60">Dashboard</button>
            <button onClick={() => navigate('/sales/invoices')} className="w-full text-left px-3 py-3 rounded-none text-ice hover:bg-ink/60">Invoices</button>
            <button onClick={() => navigate('/sales/billing')} className="w-full text-left px-3 py-3 rounded-none bg-brand/10 text-ice">Payments</button>
            <button onClick={() => navigate('/sales/ledger')} className="w-full text-left px-3 py-3 rounded-none text-ice hover:bg-ink/60">Ledger</button>
          </nav>
        </aside>

        {/* Main content */}
        <main className="flex-1">
          <div className="mb-6">
            <h1 className="text-ice text-3xl font-bold">Payments</h1>
            <div className="text-mist/70 text-sm">Local VISA Payment Processing (Execution Console)</div>
          </div>

          <div className="max-w-6xl">
            <div className="border border-edge/50 rounded-hard p-6 bg-ink/10">
              <div className="mb-6">
                {qInvoiceId ? (
                  <div className="bg-ink/20 border border-edge/30 rounded p-3 text-sm text-mist/80">Processing payments for Invoice: <span className="text-ice font-medium">{invoice.invoice_id}</span></div>
                ) : (
                  <div className="grid grid-cols-12 gap-4 items-end">
                    <div className="col-span-9">
                      <label className="block text-mist text-sm mb-1">Invoice ID (optional)</label>
                      <input value={invoiceId} onChange={(e)=>setInvoiceId(e.target.value)} className="w-full bg-ink/40 border border-edge/50 text-ice px-3 py-2 text-sm rounded" placeholder="Enter invoice id to attach attempts" />
                    </div>
                    <div className="col-span-3 text-right">
                      <button onClick={() => setInvoice(prev => ({ ...prev, invoice_id: invoiceId || prev.invoice_id }))} className="bg-brand text-ink px-4 py-2 rounded">Use Invoice ID</button>
                    </div>
                  </div>
                )}
              </div>

              <div className="grid grid-cols-3 gap-6">
                <div className="col-span-2">
                  <VisaPaymentPanel invoice={invoice} onUpdateInvoice={handleUpdateInvoice} />
                </div>
                <div className="col-span-1">
                  <div className="bg-ink/10 border border-edge/40 rounded-hard p-4">
                    <h3 className="text-ice font-semibold mb-3">Payment Attempts</h3>
                    <PaymentAttemptsList attempts={invoice.paymentAttempts || []} onRetry={(a)=>{ /* handled in VisaPaymentPanel */ }} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}
